/** returns the matched part and the remaining part of the text */
const getSuggestionHighlight = (input: string, text: string): [string, string] => {
    const firstPart = text.substring(0, input.length);
    if (firstPart.toLowerCase() !== input.toLowerCase()) {
        return ["", text];
    }
    const matchedString = firstPart;
    const remaining = text.substring(input.length);

    return [matchedString, remaining];
};

export default getSuggestionHighlight;
